<p>debugmessage works!</p>


<div class="modal is-active" [formGroup]="Form">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Debug Message Details</p>
    </header>

    @if (IsLoaded) {
      <div>
        <section class="modal-card-body" style="width: 80em; min-width: 80em; max-width: 100em;">
          @if (decodeMessageDetails) {
            <app-tabs>
              <app-tab Title="Details">
                <div style="word-wrap: break-word">
                  {{decodeMessageDetails.MessageDetails}}
                </div>
              </app-tab>
              <app-tab Title="NmeaMessage">
                <div style="word-wrap: break-word">
                  {{decodeMessageDetails.NmeaMessage}}
                </div>
                <br>
                  <div style="text-align: left;">
                    <b>NmeaMessageValues</b>
                    @for (item of decodeMessageDetails.NmeaMessageValues; track item) {
                      <div>
                        {{item}}
                      </div>
                    }
                  </div>
                </app-tab>
                <app-tab Title="FrogMessage">
                  @for (item of decodeMessageDetails.FrogMessageValues; track item) {
                    <div>
                      {{item}}
                    </div>
                  }
                </app-tab>
              </app-tabs>
            } @else {
              Unable to decode message <br>
              <div>
                <label>Message Details</label>
                <p>{{DebugMessage}}</p>
              </div>
              <div>
                <label>Message Type</label>
                <p>{{PayloadType}}</p>
              </div>
            }
          </section>
        </div>
      } @else {
        <section class="modal-card-body" style="width: 600px; min-width: 600px; max-width: 1000px;">
          <p>Decoding... Please wait</p>
        </section>
      }



      <footer class="modal-card-foot">
        <button class="button is-success" (click)="confirm()">OK</button>
      </footer>
    </div>

  </div>